import { render } from "./PlayerComplaintsPage.vue?vue&type=template&id=dfc2c06c&ts=true"
import script from "./PlayerComplaintsPage.vue?vue&type=script&lang=ts"
export * from "./PlayerComplaintsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/PlayerComplaints/PlayerComplaintsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dfc2c06c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dfc2c06c', __exports__)) {
    api.reload('dfc2c06c', __exports__)
  }
  
  module.hot.accept("./PlayerComplaintsPage.vue?vue&type=template&id=dfc2c06c&ts=true", () => {
    api.rerender('dfc2c06c', render)
  })

}


export default __exports__